// 各市州今日征订数据对比模块
const state = {
  list: []
}

const mutations = {
  SET_DATA(state, data) {
    if (data && Array.isArray(data)) {
      state.list = data.map(item => ({
        cityName: item.cityName,
        my: item.my || 0,      // 码洋
        zdrs: item.zdrs || 0   // 征订人数
      }))
    } else {
      state.list = []
    }
  },
  RESET_DATA(state) {
    state.list = []
  }
}

const getters = {
  list: state => state.list,
  // 按码洋排序
  sortedByAmount: state => {
    return [...state.list].sort((a, b) => b.my - a.my)
  },
  // 按人数排序
  sortedByPeople: state => {
    return [...state.list].sort((a, b) => b.zdrs - a.zdrs)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
